+
<div style="padding:20px" class="uc-planner-block">
  <div *ngIf="!isSearchVisible" class="search-toggle-container" style="margin-bottom:20px">
    <button mat-raised-button color="warn" (click)="isSearchVisible = true">
      <mat-icon>search</mat-icon> {{'Search' | translate | async}}
    </button>
  </div>
  <mat-card *ngIf="isSearchVisible">
    <div class="panel__header">
      <button mat-icon-button (click)="isSearchVisible = false">
        <mat-icon>close</mat-icon>
      </button>
      <span class="panel__header__title">{{'Planner' | translate | async}}</span>
    </div>
    <div class="row ">
      <div class="col-lg-12">
        <mat-form-field class="col-lg-4">
          <input matInput #customerAutoCompleteInput (focus)="focus(1)" placeholder="{{'Customer' | translate | async}}"
            aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
          <mat-autocomplete #autoCustomer="matAutocomplete"
            (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
            <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
              <span>{{ customer.Title
                }}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col-lg-4">
          <input matInput (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder="{{'Jobsite' | translate | async}}"
            aria-label="jobsite" [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">
          <mat-autocomplete #autoJobsite="matAutocomplete"
            (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
            <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
              <span>{{ jobsite.Title }}</span>
              <small></small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col-lg-4">
          <input matInput (focus)="focus(4)" #familyAutoCompleteInput placeholder="{{ 'Family' | translate | async}}"
            aria-label="Family" [matAutocomplete]="autoFamily" [formControl]="familyCtrl">
          <mat-autocomplete #autoFamily="matAutocomplete"
            (optionSelected)="familySelected($event,familyAutoCompleteInput)">
            <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
              <span>{{ family.Title }}</span> |
              <small>{{family.Symbol}}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field class="col-lg-4">

          <input matInput (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{ 'Make' | translate | async}}"
            aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">

          <mat-autocomplete #autoMake="matAutocomplete" (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
            <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
              <span>{{ make.Title }}</span> |
              <small>{{make.Symbol}}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field class="col-lg-4">
          <mat-chip-list #modelChipList>
            <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(6)" [selectable]="false"
              [removable]="true" (removed)="popMultipleSelection(6, item.SearchId, item.SearchStr)">
              {{item.Title}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input matInput [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false" (focus)="focus(6)" #modelAutoCompleteInput
              placeholder="{{ 'Model' | translate | async}}" aria-label="Model" [matAutocomplete]="autoModel"
              [formControl]="modelCtrl">
          </mat-chip-list>
          <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="modelDisplayMapper"
            (optionSelected)="modelSelected($event,modelAutoCompleteInput)">
            <mat-option *ngFor="let model of filteredModels | async" [value]="model">
              <span>{{ model.Title }}</span>
              <small></small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="row " style="text-align: right;">
          <button mat-raised-button  (click)="exportCSVClicked()">  <mat-icon>save_alt</mat-icon> Download
          </button>
          <button mat-raised-button (click)="resetFields()" style="margin-left: 20px;"> {{'Reset' | translate | async}} </button>
          <button mat-raised-button color="warn" (click)="GenerateData()" style="margin-left: 20px;margin-right: 20px;">
            {{'Generate' | translate | async}}
          </button>
    </div>
  </mat-card>
  <div>
    <div *ngIf="isOptionsVisible">
      <button mat-icon-button (click)="isOptionsVisible=false">
        <mat-icon class="icon_font_size">arrow_drop_up</mat-icon>
      </button>
    </div>
    <div *ngIf="!isOptionsVisible">
      <button mat-raised-button color="warn" (click)="isOptionsVisible=true">
        {{'Tools & Actions' | translate | async}}
      </button>
    </div>
    <div class="flex columns div-margin-top " [class.toggle-display-options]="isOptionsVisible" [@enterAnimation]
      *ngIf="isOptionsVisible">
      <div class="panel panel--tasks" style="flex-shrink: 0.1;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Display Options' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button" (click)="DisplaySettingsPopup(5)">
            <i class="material-icons square-button__icon"
              title="Update user settings to advanced user to access other tasks">view_timeline</i>
            <span class="square-button__label">{{'Interval' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="DisplaySettingsPopup(4)">
            <i class="material-icons square-button__icon">settings</i>
            <span class="square-button__label">{{'Component' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="DisplaySettingsPopup(1)">
            <i class="material-icons square-button__icon">bar_chart</i>
            <span class="square-button__label">{{'Columns' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="DisplaySettingsPopup(2)">
            <i class="material-icons square-button__icon">date_range</i>
            <span class="square-button__label">{{'Dates' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="DisplaySettingsPopup(3)">
            <i class="material-icons square-button__icon">pending_actions</i>
            <span class="square-button__label">{{'Legend' | translate | async}}</span>
          </a>
        </div>
      </div>

      <div class="panel panel--tasks" style="flex-shrink:0.1;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Tasks' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button" style="margin-right: 20px;" (click)="NavigateToSearch(1)">
            <i class="material-icons square-button__icon">task</i>
            <span class="square-button__label">{{'Enter SMU/Dates' | translate | async}}</span>
          </a>
          <a class="square-button" style="margin-right: 20px;">
            <i class="material-icons square-button__icon" (click)="DisplaySettingsPopup(8)"
              style="transform: rotateY(0deg) rotate(45deg);">check_box_outline_blank</i>
            <span class="square-button__label">{{'Actions' | translate | async}}</span>
          </a>
          <a class="square-button" (click)="NavigateToSearch(2)">
            <i class="material-icons square-button__icon">search</i>
            <span class="square-button__label">{{'Action Search' | translate | async}}</span>
          </a>
        </div>
      </div>

      <div class="panel panel--tasks" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Favorites' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button" (click)="DisplaySettingsPopup(6)">
            <i class="material-icons square-button__icon">favorite</i>
            <span class="square-button__label">{{'Create Favorite' | translate | async}}</span>
          </a>
          <ng-container *ngFor="let favorite of userFavorites" class="favourites">
            <a class="square-button" [ngStyle]="{'background-color':favorite.BackgroundColor}">
              <span class="square-button__label" [ngStyle]="{'color':favorite.TextColor}"
                (click)="getFavorite(favorite.Id)" style="margin-top: 15px;font-size: 16px;">{{favorite.Name}}</span>
              <i class="material-icons button__icon" [ngStyle]="{'color':favorite.TextColor}"
                matTooltip="Edit Favourite" [matMenuTriggerFor]="menu" style="transform: rotate(90deg);">more_vert</i>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="DisplaySettingsPopup(15,favorite)">
                <mat-icon>edit</mat-icon>
                <span>{{'Update to Current Selection' | translate | async}}</span>
              </button>
              <button mat-menu-item (click)="DisplaySettingsPopup(16,favorite)">
                <mat-icon>delete_forever</mat-icon>
                <span>{{'Delete' | translate | async}}</span>
              </button>
            </mat-menu>
          </ng-container>
        </div>
      </div>
      <!-- <div class="panel panel--tasks" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Download' | translate | async}}
          </span>
        </div>
        <div class="panel__content flex flex--align-stretch">
          <a class="square-button">
            <i class="material-icons square-button__icon" style="margin-top: 8px;"
              (click)="exportCSVClicked()">download</i>
            <span class="square-button__label"></span>
          </a>
        </div>
      </div> -->
      <!-- <div class="panel panel--tasks" style="margin-left:15px;">
        <div class="panel__header">
          <span class="panel__header__title">
            {{'Preparing Planner' | translate | async}}
          </span>
        </div>
        <div class="flex flex--align-stretch" style="margin-top:40px;flex-direction: row-reverse;">
          
        </div>
      </div> -->
    </div>
  </div>

  <div style="text-align: center;margin-left:50%">
    <mat-spinner *ngIf="FleetTableLoader" class=""></mat-spinner>
  </div>
  <div class="dashboard-wrapper" *ngIf="IsTableShow">
    <table class="data-table">
      <thead>
        <tr class="th-row sticky-row-1">
          <!-- Fixed Columns Headers (Left) -->
          <th class="sticky-col col-1-header" [style.left.px]="0"></th>
          <th class="sticky-col col-2-header" *ngIf="ColumnList.Make" [style.left.px]="60">{{'Make' | translate |
            async}}</th>
          <th class="sticky-col col-3-header" [style.left.px]="getLeftPosition(3)">{{'Model' | translate | async}}</th>
          <th class="sticky-col col-4-header" [style.left.px]="getLeftPosition(4)">{{'Unit' | translate | async}}</th>
          <th class="sticky-col col-5-header" [style.left.px]="getLeftPosition(5)">{{'SMU' | translate | async}}</th>
          <th>{{'Distance' | translate | async}} ({{userUOD}}) </th>
          <th *ngIf="ColumnList.LastInspection">
            {{'Last Inspect. Worn % Header' | translate | async}}
          </th>
          <th *ngIf="ColumnList.Position">{{'% Worn Today' | translate | async}}</th>
          <th *ngIf="ColumnList.NextPmService">{{'Next Pm Service Header' | translate | async}}</th>
          <th *ngIf="ColumnList.SecondPmService">{{'2nd Pm Service Header' | translate | async}}</th>
          <th *ngIf="ColumnList.NextPmService">{{'Floating Pm1 Service Header' | translate | async}}</th>
          <th *ngIf="ColumnList.SecondPmService">{{'Floating Pm2 Service Header' | translate | async}}</th>
          <th *ngIf="ColumnList.Worn_100">{{'100 % Worn Header' | translate | async}}</th>
          <th *ngIf="ColumnList.Worn_120">{{'120 % Worn Header' | translate | async}}</th>

          <!-- Scrollable Columns Headers (Right) -->
          <th colspan="30" *ngFor="let month of uniqueMonths">
            <div style="display:flex; flex-direction: column;">
              <div>{{month.MonthName}} {{month.YearNo}}</div>
              <div>{{month.MonthlyBudget |currency:'USD':'symbol':'1.0-0'}}</div>
            </div>

          </th>
        </tr>
        <tr class="th-row sticky-row-2" *ngIf="intervel==1" style="white-space: nowrap;text-align: center;">

          <th class="sticky-col col-1-data" [style.left.px]="0"></th>
          <th class="sticky-col col-2-data" *ngIf="ColumnList.Make" [style.left.px]="60"></th>
          <th class="sticky-col col-3-data" [style.left.px]="getLeftPosition(3)"></th>
          <th class="sticky-col col-4-data" [style.left.px]="getLeftPosition(4)"></th>
          <th class="sticky-col col-5-data" [style.left.px]="getLeftPosition(5)"></th>
          <th></th>
          <th *ngIf="ColumnList.LastInspection"></th>
          <th *ngIf="ColumnList.Position"></th>
          <th *ngIf="ColumnList.NextPmService"></th>
          <th *ngIf="ColumnList.SecondPmService"></th>
          <th *ngIf="ColumnList.FloatingPm1Service"></th>
          <th *ngIf="ColumnList.FloatingPm2Service"></th>
          <th *ngIf="ColumnList.Worn_100"></th>
          <th *ngIf="ColumnList.Worn_120"></th>

          <th *ngFor="let item of GraphHeaderData" colspan="7" class="text-align week-border">{{
            item.WeekStart |
            date: 'dd MMM' }} - {{
            item.WeekEnd | date: 'dd MMM' }} <br> <span style="text-align: center;"> {{ item.WeekNo
              }}</span>
            <br>
            <span style="text-align: center;"> {{ item.WeekLyBudget| currency:'USD':'symbol':'1.0-0' }}
            </span>

          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of ucFleetEquipmentDetail">
          <tr>
            <!-- Fixed Columns Data (Left) -->
            <td class="sticky-col col-1-data z-index-high " [style.left.px]="0">
              <a *ngIf="!item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                <i class="material-icons square-button__icon">add</i>
              </a>
              <a *ngIf="item.IsExpanded" (click)="toggleExpansion(item,1)" style="cursor: pointer;">
                <i class="material-icons square-button__icon">remove</i>
              </a>
            </td>
            <td class="sticky-col col-2-data z-index-high " *ngIf="ColumnList.Make" [style.left.px]="60">{{ item.Make }}
            </td>
            <td class="sticky-col col-3-data z-index-high " [style.left.px]="getLeftPosition(3)">{{ item.Model }}</td>
            <td class="sticky-col col-4-data z-index-high " [style.left.px]="getLeftPosition(4)">{{ item.Unit }}</td>
            <td class="sticky-col col-5-data z-index-high " [style.left.px]="getLeftPosition(5)">{{ item.SMU }}</td>
            <td>{{ convertDistanceKmToMi(item.LTD) }}</td>
            <td *ngIf="ColumnList.LastInspection">{{item.LastPmDate |date: 'dd MMM yyyy'}}<br>{{item.LastPmSMU |           number: '1.0-0'}}<br>{{item.LastPmDOE | number: '1.0-0'}}</td>
            <td class=" " *ngIf="ColumnList.Position">{{item.TodayDate |date: 'dd MMM yyyy'}}<br>{{item.TodaySMU|              number:'1.0-0'}}<br>{{item.TodayDOE | number: '1.0-0'}}</td>
            <td class="" *ngIf="ColumnList.NextPmService">{{item.NextPmDate |date: 'dd MMM yyyy'}}<br>{{item.NextPmSMU|              number: '1.0-0'}}<br>{{item.NextPmDOE | number: '1.0-0'}}</td>
            <td class="" *ngIf="ColumnList.SecondPmService"> {{item.SecondPmDate |date: 'dd MMM              yyyy'}}<br>{{item.SecondPmSMU| number: '1.0-0'}}<br>{{item.SecondPmDOE | number:
              '1.0-0'}}</td>

            <td class="" *ngIf="ColumnList.FloatingPm1Service">{{item.FloatingPm1Date |date: 'dd MMM              yyyy'}}<br>{{item.FloatingPm1SMU| number: '1.0-0'}}<br>{{item.FloatingPm1DOE | number: '1.0-0'}}</td>
            <td class="" *ngIf="ColumnList.FloatingPm2Service"> {{item.FloatingPm2Date |date: 'dd MMM              yyyy'}}<br>{{item.FloatingPm2SMU| number: '1.0-0'}}<br>{{item.FloatingPm2DOE | number:
              '1.0-0'}}</td>

            <td class="" *ngIf="ColumnList.Worn_100"></td>
            <td *ngIf="ColumnList.Worn_120"><mat-icon
                (click)="OpenSettingForecast(item,item.LastInspectionId, item.Unit)">settings</mat-icon>
              <mat-icon style="transform: rotateY(0deg) rotate(45deg);"
                (click)="NavigateToInterpretation(item.LastInspectionId)">check_box_outline_blank</mat-icon>
            </td>
            <!-- Scrollable Columns Data (Right) -->
            <ng-container *ngIf="!item.IsExpanded">
              <td *ngFor="let day of DaysArr" style="border:0px;height: 72px;position: relative; overflow: visible;"
                class="border-top-bottom">
                <div style="position: absolute; left: 0;top: 0; z-index: 10;">
                  <div class="summary-align">

                    <span *ngIf="item.NextPmDays==day" class="circle green"></span>
                    <span *ngIf="item.NextPmDays==day">{{item.PM1ServiceTypeName}} PM1</span>
                    <span *ngIf="item.SecondPmDays==day" class="circle green"></span>
                    <span *ngIf="item.SecondPmDays==day">{{item.PM2ServiceTypeName}} PM2</span>
                    <span *ngIf="item.FloatingPm1Days==day" class="circle green"></span>
                    <span *ngIf="item.FloatingPm1Days==day">{{item.Floating1ServiceTypeName}} PM3</span>
                    <span *ngIf="item.FloatingPm2Days==day" class="circle green"></span>
                    <span *ngIf="item.FloatingPm2Days==day">{{item.Floating2ServiceTypeName}} PM4</span> &nbsp;
                  </div>
                  <ng-container *ngFor="let sum of item.Summary">
                    <div class="summary-align">
                      <span *ngIf="sum.ActionDateDays== day && sum!=null" class="circle blue"></span>
                      <div class="tooltip-container" *ngIf="sum.ActionDateDays== day ">
                        <span class="always-tooltip" [matTooltip]="getTooltip(sum.ActionCodeDescription)"
                          *ngIf="sum.ActionCode">{{sum.ActionCode}}</span>
                      </div>
                      <span *ngIf="sum.ActionDateDays== day && sum.Price>0" class="circle pink"></span>
                      <span *ngIf="sum.ActionDateDays== day &&sum.Price>0">{{sum.Price |
                        currency:'USD':'symbol':'1.0-0' }}</span>
                    </div>
                  </ng-container>
                </div>
              </td>
            </ng-container>
            <ng-container *ngIf="intervel==1 && item.IsExpanded">
              <ng-container *ngFor="let weekly of item.Weekly">
                <td colspan="7" class="text-align"> {{weekly.TotalWeekPrice |currency:'USD':'symbol':'1.0-0'}}</td>
              </ng-container>
            </ng-container>
          </tr>
          <ng-container *ngIf="item.IsExpanded">
            <div style="text-align: center;margin-left:50%">
              <mat-spinner *ngIf="graphLoader" class=""></mat-spinner>
            </div>
            <tr>
              <td class="sticky-col col-1-data z-index-high " [style.left.px]="0"></td>
              <td class="sticky-col col-2-data z-index-high " *ngIf="ColumnList.Make" [style.left.px]="60"></td>
              <td class="sticky-col col-3-data z-index-high " [style.left.px]="getLeftPosition(3)"></td>
              <td class="sticky-col col-4-data z-index-high " [style.left.px]="getLeftPosition(4)"></td>
              <td class="sticky-col col-5-data z-index-high " [style.left.px]="getLeftPosition(5)"></td>
              <td></td>
              <td *ngIf="ColumnList.LastInspection">
                <span style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                  <div style="text-align: -webkit-center !important ; display: inline-block;">
                  </div>
                </span>
              </td>
              <td *ngIf="ColumnList.Position">

              </td>
              <td *ngIf="ColumnList.NextPmService"> </td>
              <td *ngIf="ColumnList.SecondPmService"> </td>
              <td *ngIf="ColumnList.FloatingPm1Service"> </td>
              <td *ngIf="ColumnList.FloatingPm2Service"> </td>
              <td *ngIf="ColumnList.Worn_100"></td>
              <td *ngIf="ColumnList.Worn_120"></td>
              <td *ngFor="let day of DaysArr"
                style="border:0px;border-bottom: 1px solid #ccc;;border-top: 1px solid #ccc;">
                <!-- <span *ngIf="item.NextPmDays==day">{{item.PM1ServiceTypeName}}</span>
                            <span *ngIf="item.SecondPmDays==day">{{item.PM2ServiceTypeName}}</span> -->
                <div class="summary-align">
                  <span *ngIf="item.NextPmDays==day" class="circle green"></span>
                  <span *ngIf="item.NextPmDays==day">{{item.PM1ServiceTypeName}} PM1</span>
                  <span *ngIf="item.SecondPmDays==day" class="circle green"></span>
                  <span *ngIf="item.SecondPmDays==day">{{item.PM2ServiceTypeName}} PM2</span>
                  <span *ngIf="item.FloatingPm1Days==day" class="circle green"></span>
                  <span *ngIf="item.FloatingPm1Days==day">{{item.Floating1ServiceTypeName}} PM3</span>
                  <span *ngIf="item.FloatingPm2Days==day" class="circle green"></span>
                  <span *ngIf="item.FloatingPm2Days==day">{{item.Floating2ServiceTypeName}} PM4</span>
                </div>
                <ng-container *ngFor="let sum of item.Summary">
                  <div class="summary-align">
                    <span *ngIf="sum.ActionDateDays== day && sum!=null" class="circle blue"></span>
                    <!-- <div *ngIf="sum.ActionDateDays== day "  class="my-box always-hover"></div> -->
                    <div class="tooltip-container" *ngIf="sum.ActionDateDays== day ">
                      <span class="always-tooltip" [matTooltip]="getTooltip(sum.ActionCodeDescription)"
                        *ngIf="sum.ActionCode">{{sum.ActionCode}}</span>
                    </div>
                    <span *ngIf="sum.ActionDateDays== day && sum.Price>0" class="circle pink"></span>
                    <span *ngIf="sum.ActionDateDays== day &&sum.Price>0">{{sum.Price | currency:'USD':'symbol':'1.0-0'
                      }}</span>
                  </div>
                </ng-container>
              </td>
            </tr>
            <div style="text-align: center;margin-left:50%">
              <mat-spinner *ngIf="componentLoader" class=""></mat-spinner>
            </div>
            <ng-container *ngFor="let item1 of item.UCPlannerComponent">
              <ng-container
                *ngIf="(item1.CompartTypeAuto==230 ||item1.CompartTypeAuto==231 ||item1.CompartTypeAuto==232) && HasSummaryTrackRoller ">
                <tr *ngIf="item1.GroupNumber==1">
                  <td class="sticky-col col-1-data z-index-high " [style.left.px]="0"></td>
                  <td class="sticky-col col-2-data z-index-high " *ngIf="ColumnList.Make" [style.left.px]="60"></td>
                  <td class="sticky-col col-3-data z-index-high " [style.left.px]="getLeftPosition(3)">{{
                    item1.SystemType }}</td>
                  <td class="sticky-col col-4-data z-index-high " [style.left.px]="getLeftPosition(4)"></td>
                  <td class="sticky-col col-5-data z-index-high " [style.left.px]="getLeftPosition(5)"></td>
                  <td></td>
                  <td *ngIf="ColumnList.LastInspection">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnLastinspction)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnLastinspction | number:'1.1-1'}}%</div>
                    </span>
                  </td>
                  <td *ngIf="ColumnList.Position">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnToday)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnToday | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.NextPmService">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnNextPm)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnNextPm | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.SecondPmService">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnSecondPm)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnSecondPm | number:'1.1-1'}}%</div>

                    </span>
                  </td>

                  <td *ngIf="ColumnList.FloatingPm1Service">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnFloating1)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnFloating1 | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.FloatingPm2Service">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtFloating2)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WornAtFloating2 | number:'1.1-1'}}%</div>

                    </span>
                  </td>

                  <td *ngIf="ColumnList.Worn_100"></td>
                  <td *ngIf="ColumnList.Worn_120"></td>
                  <td *ngFor="let day of DaysArr"
                    style="border:0px;border-bottom: 1px solid #ccc;;border-top: 1px solid #ccc;"></td>
                </tr>
              </ng-container>
              <ng-container
                *ngIf="(item1.CompartTypeAuto==233 ||item1.CompartTypeAuto==234 ||item1.CompartTypeAuto==235 ||item1.CompartTypeAuto==236) && HasSummaryRolling ">
                <tr *ngIf="item1.GroupNumber==1">
                  <td class="sticky-col col-1-data" [style.left.px]="0"></td>
                  <td class="sticky-col col-2-data" *ngIf="ColumnList.Make" [style.left.px]="60"></td>
                  <td class="sticky-col col-3-data" [style.left.px]="getLeftPosition(3)">{{ item1.SystemType }}</td>
                  <td class="sticky-col col-4-data" [style.left.px]="getLeftPosition(4)"></td>
                  <td class="sticky-col col-5-data" [style.left.px]="getLeftPosition(5)"></td>
                  <td></td>
                  <td *ngIf="ColumnList.LastInspection">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnLastinspction)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnLastinspction | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.Position">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnToday)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnToday | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.NextPmService">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnNextPm)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnNextPm | number:'1.1-1' }}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.SecondPmService">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnSecondPm)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnSecondPm | number:'1.1-1'}}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.FloatingPm1Service">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WorstWornOnFloating1)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WorstWornOnFloating1 | number:'1.1-1' }}%</div>

                    </span>
                  </td>
                  <td *ngIf="ColumnList.FloatingPm2Service">
                    <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtFloating2)"
                      style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                      <div style="text-align: -webkit-center !important ; display: inline-block;">
                        {{item1.WornAtFloating2 | number:'1.1-1'}}%</div>
                    </span>
                  </td>
                  <td *ngIf="ColumnList.Worn_100"></td>
                  <td *ngIf="ColumnList.Worn_120"></td>
                </tr>
              </ng-container>
              <tr style="height: 66px;">
                <td class="sticky-col col-1-data z-index-high " [style.left.px]="0"></td>
                <td class="sticky-col col-2-data z-index-high " *ngIf="ColumnList.Make" [style.left.px]="60"></td>
                <td class="sticky-col col-3-data z-index-high " [style.left.px]="getLeftPosition(3)"></td>
                <td class="sticky-col col-4-data z-index-high " [style.left.px]="getLeftPosition(4)"></td>
                <td class="sticky-col col-5-data z-index-high " [style.left.px]="getLeftPosition(5)">{{
                  item1.CompartName }}</td>
                <td></td>
                <td *ngIf="ColumnList.LastInspection">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.LastInspectionWorn)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.LastInspectionWorn | number:'1.1-1'}}%</div>
                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.LastInspectionSmu | number: '1.0-0'}} /</span><span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.LastInspectionDoe) |
                    number:'1.0-0'}}</span>
                </td>
                <td *ngIf="ColumnList.Position">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornPercentageToday)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.WornPercentageToday | number:'1.1-1'}}%</div>
                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.WornPercentageTodaySmu | number:'1.0-0'}}/</span><span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.WornPercentageTodayDoe) |
                    number:'1.0-0'}}</span>
                </td>
                <td *ngIf="ColumnList.NextPmService">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtNextPmService)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.WornAtNextPmService | number:'1.1-1'}}%</div>
                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.SMUAtNextPm | number:'1.0-0'}}/</span> <span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtNextPm) | number:'1.0-0'}}</span>
                </td>
                <td *ngIf="ColumnList.SecondPmService">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtSecondPmService)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.WornAtSecondPmService | number:'1.1-1'}}%</div>

                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.SMUAtSecondPm}}/</span><span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtSecondPm)}}</span>
                </td>


                <td *ngIf="ColumnList.FloatingPm1Service">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtFloating1)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.WornAtFloating1 | number:'1.1-1'}}%</div>
                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.SMUAtFloating1 | number:'1.0-0'}}/</span> <span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtFloating1) | number:'1.0-0'}}</span>
                </td>
                <td *ngIf="ColumnList.FloatingPm2Service">
                  <span [ngClass]="GetEvalColour(item1.CompartTypeAuto, item1.WornAtFloating2)"
                    style="width: 72px; margin-right: 0px !important; padding: 5px 8px !important;">
                    <div style="text-align: -webkit-center !important ; display: inline-block;">
                      {{item1.WornAtFloating2 | number:'1.1-1'}}%</div>

                  </span>
                  <span *ngIf="ColumnList.CMU">{{item1.SMUAtFloating2}}/</span><span
                    *ngIf="ColumnList.DOC">{{convertDistanceKmToMi(item1.DOCAtFloating2)}}</span>
                </td>

                <td *ngIf="ColumnList.Worn_100">{{item1.DateAt100Worn |date: 'dd MMM yyyy'}}</td>
                <td *ngIf="ColumnList.Worn_120">{{item1.DateAt120Worn |date: 'dd MMM yyyy'}}</td>

                <td *ngFor="let day of DaysArr"
                  [ngStyle]="{'border-right': 'none','padding': '0px','border-right': day === todayDayDiff ? '2px solid red' : 'none'}">
                  <div class="bar-container">
                    <div [ngClass]="getBarClassFast(day, item1)">
                      <ng-container *ngFor="let day2 of getRecommendationsFast(day, item1)">
                        <div *ngIf="day==day2.Days">
                          <mat-icon class="recom-Icon-color " style="position: relative;
                               bottom: -18px;left: -13px;"
                            (click)="DisplaySettingsPopup(112,'', day2.QuoteId,day2.Date,day2.ComponentId,item1.EquipmentId,day2.Smu)">navigation</mat-icon>

                          <div class="tooltip-container">
                            <span class="always-tooltip">{{day2.Date|date: 'dd MMM yyyy'}}
                              {{day2.ActionDescription}}</span>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </td>

              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>